module.exports = __webpack_public_path__ + "img/sort-handle-icon.8cb8f4b7.svg";